export default __webpack_public_path__ + "static/media/listIcon.e924f8e7.svg";